// extracted by mini-css-extract-plugin
export default {"page":"Page_page__G17PX","pageUZ":"Page_pageUZ__wrqih"};